import { render, staticRenderFns } from "./SocialBoostList.vue?vue&type=template&id=01b3eeec"
import script from "./SocialBoostList.vue?vue&type=script&lang=js"
export * from "./SocialBoostList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports